import type { NormalisedSignupCode } from '../signup-codes/signup-codes.module.types'

export const moduleName = 'admin/signup-codes-details'

export type NormalisedVolunteerGroup = {
  name: string
  id: string
  default: boolean
}

export type NormalisedSignupCodeSession = {
  usedDate: Date
  user: {
    firstName: string
    lastName: string
    email: string
    id: string
    volunteerGroups: NormalisedVolunteerGroup[]
  }
}

export type NormalisedSignupCodeDetails = {
  sessions: NormalisedSignupCodeSession[]
}

export type NormalisedCombinedSignupCodeDetails = NormalisedSignupCodeDetails & NormalisedSignupCode
